export default "__VITE_ASSET__BiJ1W2_m__"